import { Spinner } from '@wordpress/components';

const Loader = () => {
	const style = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '150px',
		width: '100%',
		backgroundColor: '#fff',
		boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px',
	};
	return (
		<div style={ style }>
			<Spinner />
		</div>
	);
};

export default Loader;
